import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import { fetchProductSchemaAndConfig } from './fetchProductSchemaAndConfig'
import { HashConflictMode } from '../../../types/configurations'
import { checkUnsavedChanges } from '../../actions/configurationActions'
import { showModal } from '../../actions/modalActions'
import { ModalTypes } from '../../../types/modals'
import { getUrlWithVersion } from '../../../api/api'

export const applyProductConfigChanges = createAsyncThunk<
    void,
    { guid: string; configuration: any; isVersionConflict: boolean | null },
    ThunkConfig<string>
>('configsSlice/applyProductConfigChanges', async (args, thunkAPI) => {
    const {
        dispatch,
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { guid, configuration, isVersionConflict } = args

    const hashConflictMode =
        isVersionConflict || isVersionConflict === null
            ? HashConflictMode.FORCE_OVERWRITE
            : HashConflictMode.PREVENT_UPDATE

    try {
        await api.post(getUrlWithVersion(`/schema_and_configuration/${guid}`), {
            ...configuration,
            hash_conflict_mode: hashConflictMode,
        })

        await dispatch(fetchProductSchemaAndConfig({ guid, forceUpdate: true }))
        dispatch(checkUnsavedChanges(guid))

        throwSuccessMessage(`Success!`)
    } catch (e) {
        alertErrorMessage(e)
        if (e?.response?.status === 409) {
            dispatch(
                showModal(ModalTypes.VERSION_OVERWRITE_MODAL, {
                    onSubmit: () =>
                        dispatch(
                            applyProductConfigChanges({
                                guid,
                                configuration,
                                isVersionConflict: true,
                            })
                        ),
                })
            )
        }
        return rejectWithValue('Failed to apply configuration ')
    }
})
